module.exports = __webpack_public_path__ + "static/STG20_Desktop_2880_Module5_Drink3_GinTonic-e7da9300cec66063921e58fe84c3d6aa.png";